
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/nearby-listings",
      function () {
        return require("private-next-pages/team/nearby-listings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/nearby-listings"])
      });
    }
  